import css from './index.module.css';

import SEO from "@components/seo";
import CartProduct from "@components/cartProduct";
import useUserData from "@hooks/useUserData";
import EmptyCart from "@pages/system/emptyCart";
import MainContent from "@components/content";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useMemo, useState } from 'react';
import { toast } from 'sonner';

export default function Cart() {
  const { cartData } = useUserData();
  const navigate = useNavigate();
  const [unavailableProductIds, setUnavailableProductIds] = useState<number[]>([]);

  const unavailableSet = useMemo(() => new Set(unavailableProductIds), [unavailableProductIds]);
  
  const totalPrice = Array.isArray(cartData)
    ? cartData.reduce((acc, cart) => acc + cart.product.price * Number(cart.count), 0)
    : 0;

  const goToCheckout = async () => {
    try {
      setUnavailableProductIds([]);
      await axios.post(`${import.meta.env.VITE_API_URL}/check`, {}, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        }
      });
      navigate('/webapp/checkout');
    } catch (error: any) {
      const status = error?.response?.status;
      const details = error?.response?.data?.details;

      if (status === 400 && Array.isArray(details)) {
        const ids = details
          .map((d: any) => Number(d?.productId))
          .filter((id: number) => Number.isFinite(id));

        setUnavailableProductIds(ids);
        toast.error('Не удалось отправить заказ. Некоторые товары недоступны. Обновите количество и попробуйте снова');
        return;
      }

      toast.error('Не удалось проверить доступность товаров');
    }
  };

  return (
  <>
    {(!cartData || cartData.length <= 0) ? 
      <EmptyCart /> :
    
    <MainContent header="Корзина">    
      <SEO 
        title={`Корзина`}
        description={`Корзина`}
        ogImage={``}
        ogUrl={``}
      />

      <div className={css.cart}>
        <Link to={`/webapp`} className={css.back}>Добавить больше товаров</Link>

        <div className={css.productList}>
          {cartData && cartData.map(cart => (
            <CartProduct 
              id={cart.id}
              prodID={cart.product.id}
              image={cart.product.images[0]}
              title={cart.product.name}
              price={cart.product.price}
              unit={cart.product.unit}
              quantity={cart.product.quantity}
              unitCart={cart.unit}
              count={cart.count}
              buttons={true}
              warning={unavailableSet.has(cart.product.id)}
            />
          ))}
        </div>

        <div className={css.cartInfo}>
          <div className={css.total}>
            <div className={`${css.item}`}>
              <a>Итоговая стоимость:</a>
              <b>{totalPrice.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽</b>
            </div>

            <button className={css.checkout} onClick={goToCheckout}>Перейти к оформлению</button>
          </div>
        </div>
      </div>
    </MainContent>
    }
    </>
  )
}